import React from "react";
import { Link, NavLink } from "react-router-dom";

const navigation = [
  { label: "Home", to: "/", end: true },
  { label: "Our Fleet", to: "/fleet" },
  { label: "Services", to: "/services" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const PhoneIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

function WebHeader() {
  return (
    <header className="web-header" aria-label="Jet Black public website header">
      <Link className="web-header__brand" to="/" aria-label="JB JET BLACK LIMOUSINE home">
        <span className="web-header__monogram" aria-hidden="true">JB</span>
        <span className="web-header__wordmark">JET BLACK</span>
        <span className="web-header__subtitle">LIMOUSINE</span>
      </Link>
      <nav className="web-header__navigation" aria-label="Public website navigation">
        {navigation.map(({ label, to, end }) => (
          <NavLink key={to} className="web-header__link" end={end} to={to}>{label}</NavLink>
        ))}
      </nav>
      <a className="web-header__phone" href="tel:+19149628444"><PhoneIcon aria-hidden="true" />(914) 962-8444</a>
      <Link className="web-header__book" to="/booking">BOOK NOW</Link>
    </header>
  );
}

export default WebHeader;
